import Modal from 'react-modal';
import clsx from 'clsx';
import { format } from 'date-fns';

import useExchange, { RateItem } from '../services/useExchange';
import './SelectTecajModal.styles.css';

// Bind the modal to the app root so screen readers hide background content
// while it's open (avoids react-modal's "App element is not defined" warning).
Modal.setAppElement('#root');

const modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

type SelectTecajModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (rate: RateItem) => void;
  currentlySelectedDate: string;
  silePareDatum: string;
};

const BROJ_DANA_UNAZAD = 30;

const SelectTecajModal = ({
  isOpen,
  onClose,
  currentlySelectedDate,
  onSelect,
  silePareDatum,
}: SelectTecajModalProps) => {
  const { isLoading, error, getRatesInRange, getBestRate } = useExchange();
  const data = getRatesInRange(silePareDatum, BROJ_DANA_UNAZAD);
  const bestRate = getBestRate(silePareDatum, BROJ_DANA_UNAZAD);

  const onItemClick = (item: RateItem) => {
    onSelect(item);
    onClose();
  };

  const renderBody = () => {
    if (isLoading) {
      return <p>Učitavanje tečajeva…</p>;
    }
    if (error) {
      return <p className="error">Greška pri dohvaćanju tečajeva. Pokušajte ponovno kasnije.</p>;
    }
    if (data.length === 0) {
      return <p>Nema dostupnih tečajeva za odabrani datum.</p>;
    }
    return (
      <table className="SelectModal">
        <tbody>
          {data.map((item) => (
            <tr
              key={item.date}
              className={clsx({
                'best-rate': bestRate?.date === item.date,
                'selected-rate': currentlySelectedDate === format(new Date(item.date), 'dd.MM.yyyy.'),
              })}
              onClick={() => onItemClick(item)}
            >
              <td>{item.date}</td>
              <td>{item.rate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyle}
      contentLabel="Odabir tecaja"
      overlayClassName="ModalOverlay"
    >
      <h3>Odaberi tecaj</h3>
      {renderBody()}
    </Modal>
  );
};

export default SelectTecajModal;
